module.exports = __webpack_public_path__ + "static/media/cone-cream-dessert-3-svgrepo-com.705d2d04.svg";